import { TaskStatusEnum } from '../../task/Config';

export const TASK_STATUS_MAPS = {
  [TaskStatusEnum.InProgress]: 'Not Yet Available',
};
